// extracted by mini-css-extract-plugin
export default {"successMessage":"MatchNotification_successMessage__cBnCL"};